import React from 'react';
import { Link } from '../atoms/link';
import { Button } from '../atoms/button';
import "../../resources/css/login/login.css";

export const ButtonLinkForm = (props) => {
    
    return(
        <div>
            <Button
                buttonText={props.buttonText}
                className={props.isWideTablet ? "loginBtnStyleSp" : "loginBtnStylePc"}
                onClick={props.onClick}
            />
            {/* <Link style={styles.link} href={"https://point.rttg.jp/"} target={"_blank"} rel={"noopener noreferrer"} linkTitle={"パスワードをお忘れですか？"}/> */}
           <Link
           className={props.isWideTablet ? "loginLinkSp" : "loginLinkPc"}
           href={props.href}
           target={props.target}
           rel={props.rel}
           linkTitle={props.linkTitle}
           />
            {/* リンクは仮 */}
        </div>
    );
}
const styles = {
    // link:{
    //     color: "gray",
    //     fontSize: 12.8,
    //     textDecoration: "underline",
    //     display:"block",
    // },
}
